import React, { useEffect, useState } from "react";

import { Button, Grid } from "@mui/material";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useQuery } from "react-query";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import QrCodeIcon from "@mui/icons-material/QrCode";
import MUIDataTable from "mui-datatables";
import { toast } from "react-toastify";

import StoreApi from "../../services/Apis/Store.Api";
import LocationApi from "../../services/Apis/Location.Api";
import { DialogForm, QrCodeDialog } from "./components";

import dynamicStyle from "./styles";
import { ConfirmDialog } from "../../components";

const Locations = () => {
  const [storeID, setStoreID] = useState("");
  const [store, setStore] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [locationID, setLocationID] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [qrcodeOpen, setQurCodeOpen] = useState(false);
  const [locationName, setLocationName] = useState(null);

  const classes = dynamicStyle();

  const { data: storesList, refetch } = useQuery("ALL_STORES_LIST", () =>
    StoreApi.getStores()
  );

  const { data: locationsList, refetch: refetchLocations } = useQuery(
    ["GET_LOCATION_BY_STORE", storeID],
    () => LocationApi.getLocationsByStore(storeID),
    {
      enabled: !!storeID,
    }
  );

  //   Mui Table Columns ..
  const columns = [
    {
      name: "ID",
      label: "ID",
    },
    {
      name: "locationName",
      label: "Location",
      options: { filterOptions: { fullWidth: true } },
    },
    {
      name: "phoneNo",
      label: "Phone No",
      options: {
        filterOptions: { fullWidth: true },
        customBodyRender: (value) => value.join(" , "),
      },
    },
    // Actions  ...
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const id = tableMeta.rowData[0];
          return (
            <>
              <IconButton
                onClick={() => handleQrCodeOpenDialog(tableMeta.rowData[1])}
              >
                <QrCodeIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleConfirmOpen(id);
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                onClick={() => {
                  handleOpenUpdateDialog(id);
                }}
              >
                <EditIcon />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  //   Mui Table Options ..
  const options = {
    search: true,
    download: true,
    print: false,
    viewColumns: true,
    filter: true,
    filterType: "dropdown",
    // responsive,
    selectableRows: "none",
  };

  // Set store ID and Store name ..
  useEffect(() => {
    if (storesList) {
      setStore(storesList[0]?.storeName);
      setStoreID(storesList[0]?.ID);
    }
  }, [storesList]);

  // Handle Click Store Select
  const hadleClick = (id, name) => {
    setStore(name);
    setStoreID(id);
  };

  // Handle clcik add location
  const handleAddLocation = () => {
    setOpenDialog(true);
  };

  // Handle Click update locaiton
  const handleOpenUpdateDialog = (id) => {
    setLocationID(id);
    setOpenDialog(true);
  };

  // Open Delete Dialog ..
  const handleConfirmOpen = (id) => {
    setLocationID(id);
    setConfirmOpen(true);
  };

  const handleDelete = async () => {
    const response = await LocationApi.deleteLocation(locationID);
    if (response.success) {
      toast.success(response.message);
      setConfirmOpen(false);
      setLocationID(null);
      refetchLocations();
      refetch();
    } else {
      toast.error("Store not deleted!");
    }
  };

  // Handle Open QR code ..
  const handleQrCodeOpenDialog = (location) => {
    setLocationName(location);
    setQurCodeOpen(true);
  };

  return (
    // Main Grid
    <Grid>
      <QrCodeDialog
        open={qrcodeOpen}
        setOpen={setQurCodeOpen}
        storeName={store}
        location={locationName}
      />
      <Grid
        contianer
        sx={{
          mt: 1,
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid item>
          <FormControl fullWidth>
            <InputLabel id="store-label">Store</InputLabel>
            <Select id="select" value={store} label="Select store">
              {storesList &&
                storesList?.map((option) => (
                  <MenuItem
                    key={option?.ID}
                    onClick={() => hadleClick(option?.ID, option?.storeName)}
                    value={option?.storeName}
                  >
                    {option?.storeName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleAddLocation}
          >
            Add new Location
          </Button>
        </Grid>
      </Grid>
      {/* Mui data table */}
      <Grid sx={{ mt: 3 }}>
        <MUIDataTable
          title={"Locations list"}
          data={locationsList}
          columns={columns}
          options={options}
        />
      </Grid>
      {/* Create and update location */}
      <Grid>
        <DialogForm
          open={openDialog}
          setOpen={setOpenDialog}
          refetchLocations={refetchLocations}
          storeID={storeID}
          setStoreID={setStoreID}
          locationID={locationID}
          setLocationID={setLocationID}
        />
      </Grid>
      {/* Delete Location  */}
      <Grid>
        <ConfirmDialog
          title="Delete Location ?"
          dialogContext="Are you sure to delete location"
          open={confirmOpen}
          setOpen={setConfirmOpen}
          onConfirm={handleDelete}
        />
      </Grid>
    </Grid>
  );
};

export default Locations;
